import { Minus, Plus } from 'lucide-react';

export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max = 99,
}: {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
}) {
  return (
    <div className="inline-flex h-10 items-center rounded-pill border border-night-blue/15">
      <button
        type="button"
        aria-label="Decrease quantity"
        onClick={() => onChange(Math.max(min, value - 1))}
        className="flex h-full w-10 items-center justify-center text-night-blue/70 hover:text-night-blue disabled:opacity-30"
        disabled={value <= min}
      >
        <Minus size={16} />
      </button>
      <span className="w-8 text-center text-sm font-bold text-night-blue">{value}</span>
      <button
        type="button"
        aria-label="Increase quantity"
        onClick={() => onChange(Math.min(max, value + 1))}
        className="flex h-full w-10 items-center justify-center text-night-blue/70 hover:text-night-blue disabled:opacity-30"
        disabled={value >= max}
      >
        <Plus size={16} />
      </button>
    </div>
  );
}
